import { Navigate, RouteObject } from 'react-router-dom'
import AuthLayout from 'layouts/AuthLayout'
import BaseLayout from 'layouts/BaseLayout'
import SignIn from 'pages/auth/SignIn'
import Orders from 'pages/orders/Orders'
import OrderConfirmation from 'pages/order-confirmation/OrderConfirmation'
import InvoiceIndex from 'pages/invoice/InvoiceIndex'
import OrderCancellation from 'pages/order-cancellation/OrderCancellation'
import InvoiceDetail from 'pages/invoice/InvoiceDetail'
import Vouchers from 'pages/loyalty/voucher/Vouchers'
import CreateVoucher from 'pages/loyalty/voucher/Create'
import DetailVoucher from 'pages/loyalty/voucher/Detail'
import OrdersDigital from '../pages/orders/OrdersDigital'
import Approvals from 'pages/approvals/Approvals'
import SawitPoinList from 'pages/sawitpoin/SawitPoinList'
import SawitPoinDetail from 'pages/sawitpoin/components/SawitPoinDetail'
import SawitPoinCreate from 'pages/sawitpoin/SawitPoinCreate'
import Campaign from 'pages/campaign/Campaign'
import CampaignDetail from 'pages/campaign/components/CampaignDetail'
import CampaignCreate from 'pages/campaign/components/CampaignCreate'
import JobVacancyIndex from 'pages/job-vacancy/JobVacancyIndex'
import JobVacancyDetail from 'pages/job-vacancy/JobVacancyDetail'
import JobVacancyForm from 'pages/job-vacancy/JobVacancyForm'
import InventoryRoutes from './InventoryRoutes'

export const PublicRoutes: RouteObject[] = [
  {
    path: '',
    element: <AuthLayout />,
    children: [
      {
        path: '/',
        element: <SignIn />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
]

export const OperationRoutes: RouteObject[] = [
  {
    path: 'orders',
    children: [
      {
        path: 'goods',
        element: (
          <BaseLayout title="Daftar Pesanan">
            <Orders />
          </BaseLayout>
        ),
      },
      {
        path: 'digital',
        element: (
          <BaseLayout title="Daftar Pesanan Digital">
            <OrdersDigital />
          </BaseLayout>
        ),
      },
      {
        path: 'cancellation',
        element: (
          <BaseLayout title="Konfirmasi Pembatalan">
            <OrderCancellation />
          </BaseLayout>
        ),
      },
    ],
  },
  InventoryRoutes(),
  {
    path: '*',
    element: <Navigate to="/orders/goods" />,
  },
]

export const OperationLeadRoutes: RouteObject[] = [
  {
    path: 'orders',
    children: [
      {
        path: 'goods',
        element: (
          <BaseLayout title="Daftar Pesanan">
            <Orders />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: 'approvals',
    children: [
      {
        path: 'list',
        element: (
          <BaseLayout title="Daftar Persetujuan">
            <Approvals />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/orders/goods" />,
  },
]

export const WarehouseRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        path: '',
        element: (
          <BaseLayout title="Pengambilan Pesanan">
            <OrderConfirmation />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
]

export const AccountantRoutes: RouteObject[] = [
  {
    path: 'invoices',
    children: [
      {
        path: 'list',
        element: (
          <BaseLayout title="Daftar Invoice">
            <InvoiceIndex />
          </BaseLayout>
        ),
      },
      {
        path: ':id',
        element: (
          <BaseLayout title="Daftar Invoice">
            <InvoiceDetail />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/invoices/list" />,
  },
]

export const AccountantLeadRoutes: RouteObject[] = [
  {
    path: 'invoices',
    children: [
      {
        path: 'list',
        element: (
          <BaseLayout title="Daftar Invoice">
            <InvoiceIndex />
          </BaseLayout>
        ),
      },
      {
        path: ':id',
        element: (
          <BaseLayout title="Daftar Invoice">
            <InvoiceDetail />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: 'approvals',
    children: [
      {
        path: 'list',
        element: (
          <BaseLayout title="Daftar Persetujuan">
            <Approvals />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: 'sawitpoin',
    children: [
      {
        path: '',
        element: (
          <BaseLayout title="Daftar Permintaan Pencarian SawitPoin">
            <SawitPoinList />
          </BaseLayout>
        ),
      },
      {
        path: 'detail/:id',
        element: (
          <BaseLayout title="Detail Permintaan">
            <SawitPoinDetail />
          </BaseLayout>
        ),
      },
      {
        path: 'request',
        element: (
          <BaseLayout title="Buat Permintaan Pencairan SawitPoin">
            <SawitPoinCreate />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/invoices/list" />,
  },
]

export const AdminRoutes: RouteObject[] = [
  {
    path: 'sawitpoin',
    children: [
      {
        path: '',
        element: (
          <BaseLayout title="Daftar Permintaan Pencarian SawitPoin">
            <SawitPoinList />
          </BaseLayout>
        ),
      },
      {
        path: 'detail/:id',
        element: (
          <BaseLayout title="Detail Permintaan">
            <SawitPoinDetail />
          </BaseLayout>
        ),
      },
      {
        path: 'request',
        element: (
          <BaseLayout title="Buat Permintaan Pencairan SawitPoin">
            <SawitPoinCreate />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: 'campaign',
    children: [
      {
        path: '',
        element: (
          <BaseLayout title="Daftar Program Agen">
            <Campaign />
          </BaseLayout>
        ),
      },
      {
        path: 'detail/:id',
        element: (
          <BaseLayout title="Detail Program" isBackNav>
            <CampaignDetail />
          </BaseLayout>
        ),
      },
      {
        path: 'create',
        element: (
          <BaseLayout title="Tambah Program Agen">
            <CampaignCreate />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: 'loyalty',
    children: [
      {
        path: 'vouchers',
        children: [
          {
            path: '',
            element: (
              <BaseLayout title="Daftar Voucher">
                <Vouchers />
              </BaseLayout>
            ),
          },
          {
            path: 'create',
            element: (
              <BaseLayout title="Tambah Voucher" isBackNav>
                <CreateVoucher />
              </BaseLayout>
            ),
          },
          {
            path: 'detail/:id',
            element: (
              <BaseLayout title="Detail Voucher">
                <DetailVoucher />
              </BaseLayout>
            ),
          },
        ],
      },
    ],
  },
  {
    path: 'job-vacancy',
    children: [
      {
        path: '',
        element: (
          <BaseLayout title="Daftar Pekerjaan">
            <JobVacancyIndex />
          </BaseLayout>
        ),
      },
      {
        path: 'create',
        element: (
          <BaseLayout title="Tambah Pekerjaan" isBackNav={true}>
            <JobVacancyForm />
          </BaseLayout>
        ),
      },
      {
        path: 'edit/:jobId',
        element: (
          <BaseLayout title="Ubah Pekerjaan" isBackNav={true}>
            <JobVacancyForm />
          </BaseLayout>
        ),
      },
      {
        path: ':jobId',
        element: (
          <BaseLayout title="Detail Pekerjaan" isBackNav={true}>
            <JobVacancyDetail />
          </BaseLayout>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/loyalty/vouchers" />,
  },
]
